import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Attachment } from '../../../_interfaces/Attachment';
import { DarkmodeService } from '../../../_provider/darkmode.service';
import { TicketEmployee } from '../../../_provider/tickets/ticket.service';
import { AuthService, ROLE } from 'src/app/_provider/auth.service';
import { WawiConnectorService } from 'src/app/_provider/wawi-connector/wawi-connector.service';
@Component({
    selector: 'app-ticket-detail-assets',
    templateUrl: './ticket-detail-assets.component.html',
    styleUrls: ['./ticket-detail-assets.component.scss'],
    standalone: false
})

export class TicketDetailAssetsComponent{

  @ViewChild("content", {static: false}) content: ElementRef
  @Input() canDelete: boolean = true
  public isDarkmode: boolean
  
  private darkmodeSub: Subscription

  constructor(
    private darkmode: DarkmodeService,
    public ticketSrv: TicketEmployee.TicketService,
    private authSrv: AuthService,
    private wawiConnectorSrv: WawiConnectorService
  ) { 
    this.darkmodeSub = this.darkmode.isDarkMode.subscribe(result=>{
      if(result !== null)this.isDarkmode = result
    }) 
  }

  async ngOnInit(){
    await this.wawiConnectorSrv.initConnector()
  }

  ngOnDestroy(){
    this.darkmodeSub.unsubscribe()
  }

  public addFile(file: Attachment){
    if(file) (this.ticketSrv as TicketEmployee.TicketService).addFile(file)
  }
}
